import { render, staticRenderFns } from "./create-material-modal.vue?vue&type=template&id=93204bd2&scoped=true"
import script from "./create-material-modal.vue?vue&type=script&lang=js"
export * from "./create-material-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93204bd2",
  null
  
)

export default component.exports